import { render } from "./LoadingDots.vue?vue&type=template&id=53b520de&scoped=true"
import script from "./LoadingDots.vue?vue&type=script&lang=js"
export * from "./LoadingDots.vue?vue&type=script&lang=js"

import "./LoadingDots.vue?vue&type=style&index=0&id=53b520de&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53b520de"],['__file',"src/components/elements/waiter/LoadingDots.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53b520de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53b520de', __exports__)) {
    api.reload('53b520de', __exports__)
  }
  
  module.hot.accept("./LoadingDots.vue?vue&type=template&id=53b520de&scoped=true", () => {
    api.rerender('53b520de', render)
  })

}


export default __exports__